import { hasOverlapCorrection } from '@/helpers/overlap_updates_format'

/** Hide skipped rows when no explicit status filter is selected. */
export function excludeSkippedUnlessSelected(items, selectedStatus) {
  if (!items)
    return []
  if (selectedStatus != null)
    return items
  return items.filter(item => item.status !== 'skipped')
}

/** Subset of actuals rows matching the selected status chip (for dependent counts). */
export function filterActualsItemsByStatus(items, selectedStatus, { isHosDiffOverThreshold } = {}) {
  if (!items)
    return []
  if (selectedStatus == null)
    return items
  if (selectedStatus === 'driver_overlap')
    return items.filter(item => item.driver_overlap)
  if (selectedStatus === 'vehicle_overlap')
    return items.filter(item => item.vehicle_overlap)
  if (selectedStatus === 'overlap_correction')
    return items.filter(item => hasOverlapCorrection(item))
  if (selectedStatus === 'hos_diff_over_threshold') {
    if (!isHosDiffOverThreshold)
      return items
    return items.filter(item => isHosDiffOverThreshold(item))
  }
  return items.filter(item => item.status === selectedStatus)
}
